import React, {useContext, useMemo} from 'react';
import {NavLink} from 'react-router-dom';

// Components
import VideoPlayer from "../../Components/Layouts/Content/Watch/VideoSingle/VideoPlayer/VideoPlayer";
import CarouselLandscape from "../../Components/Layouts/Content/Carousels/CarouselLandscape";

// Constants
import {RoutePaths} from "../../Constants/RoutePaths";

// Hooks
import useFetchSpecificContentItems from "../../Hooks/Content/Watch/VideoSingle/useFetchSpecificContentItems";
import useFetchCategoryMixedContent from "../../Hooks/Content/Watch/MixedContentFeed/useFetchCategoryMixedContent";

// Context
import {GlobalInterfaceContext} from "../../Context/GlobalInterfaceContext";
import {UserAuthenticationContext} from "../../Context/UserAuthenticationContext";

// Assets
import ClassicCollection from '../../Assets/Images/DavidIckePage/classic-collection.jpg';
import FilmsCollection from '../../Assets/Images/DavidIckePage/films-collection.jpg';
import LiveCollection from '../../Assets/Images/DavidIckePage/live-collection.jpg';
import StarsBackground from '../../Assets/Images/DavidIckePage/stars-background.jpg';
import SeriesCollection from '../../Assets/Images/DavidIckePage/david-series-collection.png';

const DavidIckeRoot = () => {
    const
        { isDarkMode } = useContext(GlobalInterfaceContext),
        items = [
            { id: '1', to: RoutePaths.DavidIckeLive, img: `${LiveCollection}`, label: 'Live Collection' },
            { id: '2', to: RoutePaths.DavidIckeFilms, img: `${FilmsCollection}`, label: 'All Films' },
            { id: '3', to: RoutePaths.DavidIckeSeries, img: `${SeriesCollection}`, label: 'All Series' },
            // { id: '4', to: RoutePaths.DavidIcke, img: '/img2.jpg', label: 'Bucket #4' },
        ],

        authCtx = useContext(UserAuthenticationContext),

        // User data
        userId = authCtx.userData?.id ?? "1c624ef2-27a9-496f-b518-6f6e612078b6",
        countryCode = "GB",

        startingToQuestionIds = useMemo(
            () => [
                { type: "Series", id: 121 },
                { type: "Series", id: 181 },
                { type: "Series", id: 19 },
                { type: "Film", id: 3070 },
                { type: "Series", id: 154 },
                { type: "Film", id: 582 },
                { type: "Series", id: 171 },


            ],
            []
        ),
        {
            items: startingToQuestionItems,
            loading: startingToQuestionLoading,
            error: startingToQuestionError
        } = useFetchSpecificContentItems(startingToQuestionIds, countryCode, userId),

        biggerPictureIds = useMemo(
            () => [

                { type: "Series", id: 122 },
                { type: "Film", id: 2190 },
                { type: "Series", id: 184 },
                { type: "Series", id: 156 },
                { type: "Series", id: 97 },
                { type: "Series", id: 124 },
            ],
            []
        ),
        {
            items: biggerPictureItems,
            loading: biggerPictureLoading,
            error: biggerPictureError
        } = useFetchSpecificContentItems(biggerPictureIds, countryCode, userId),

        multiDimensionalIds = useMemo(
            () => [
                { type: "Film", id: 2688 },
                { type: "Film", id: 1568 },
                { type: "Film", id: 1026 },
                { type: "Series", id: 29 },
                { type: "Series", id: 178 },
            ],
            []
        ),
        {
            items: multiDimensionalItems,
            loading: multiDimensionalLoading,
            error: multiDimensionalError
        } = useFetchSpecificContentItems(multiDimensionalIds, countryCode, userId),

        {
            content: categoryContent,
            loading: contentLoading,
        } = useFetchCategoryMixedContent(17, 30, 0, false, "desc", true);


    return (
        <div className="page page--david-icke">
            <section className="david-icke__info u-relative_hidden">
                <div className="u-full_cover_absolute"
                     style={{background: `url('${StarsBackground}') center/cover no-repeat`}}/>

                <div className="banner__two-column">
                    <div className="banner__david-bio">
                        <h1>
                            David Icke
                        </h1>

                        <h3>
                            World Renowned Author and Researcher
                        </h3>

                        <p>
                            A visionary thinker unafraid to challenge the status quo. Through decades of research and
                            fearless exploration, David exposes hidden truths and unveils the deeper mechanisms shaping
                            our reality.
                        </p>
                    </div>

                    <div className="banner__video-player u-relative_hidden">
                        <VideoPlayer
                            src="https://storage.ickonic.com/IckonicVideo/asset-2e0d2de6-0103-4842-b433-985f901ca02a/David_Icke_Social_Content__2.m3u8"
                            poster={ClassicCollection}
                            autoPlay={false}
                            playbackAllowed={true}
                        />
                    </div>
                </div>
            </section>

            <section className="david-icke__menu-grid">
                {items.map(item => (
                    <NavLink
                        key={item.id}
                        to={item.to}
                        className="david-icke__menu-grid-item u-relative_hidden"
                    >
                        <div className="u-full_cover_absolute"
                             style={{background: `url(${item.img}) center/cover no-repeat`}} />
                        <p>{item.label}</p>
                    </NavLink>
                ))}
            </section>

            <section className="david-icke__section david-icke__latest">
                <div className="david-icke__section-row">
                    <CarouselLandscape
                        isDarkMode={isDarkMode}
                        heading="The Latest From David"
                        carouselItems={contentLoading ? undefined : categoryContent}
                        buttonText="View All"
                        buttonLink={RoutePaths.Category(17)}
                    />
                </div>
            </section>

            <section className="david-icke__section david-icke__funnel-section">
                <h1>
                    Truth is a journey. Where are you now?
                </h1>

                <div className="david-icke__section-row">
                    <CarouselLandscape
                        isDarkMode={isDarkMode}
                        heading="I’m just starting to question the narrative"
                        carouselItems={startingToQuestionLoading ? undefined : startingToQuestionItems}
                        buttonText="View All"
                    />
                </div>

                <div className="david-icke__section-row">
                    <CarouselLandscape
                        isDarkMode={isDarkMode}
                        heading="I want to see the bigger picture"
                        carouselItems={biggerPictureLoading ? undefined : biggerPictureItems}
                        buttonText="View All"
                    />
                </div>

                <div className="david-icke__section-row">
                    <CarouselLandscape
                        isDarkMode={isDarkMode}
                        heading="I’m ready to explore the non-human and multidimensional"
                        carouselItems={multiDimensionalLoading ? undefined : multiDimensionalItems}
                        buttonText="View All"
                    />
                </div>
            </section>
        </div>
    )
};

export default DavidIckeRoot;
